exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".async-email-input-progress-icon {\n  position: absolute;\n  font-size: 24px;\n  bottom: -0.2em;\n  right: -35px;\n}\n@media (max-width: 991px) {\n  .async-email-input-progress-icon {\n    bottom: -0.3em;\n  }\n}\n", ""]);

